module.exports = __webpack_public_path__ + "images/pages/injection-guidelines/transoral-step-1.png";